/*= ========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

import {setAuthorizationHeader} from '../../axios';

export default {
  SET_BEARER() {
    //axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    //localStorage.setItem('accessToken', accessToken);

    // setting ulang header
    setAuthorizationHeader(window.restApi);
  },
};
